import React from "react";
import { Card } from "@/components/ui/card";

const COLS = { 2: "xl:grid-cols-2", 3: "xl:grid-cols-3", 4: "xl:grid-cols-4", 5: "xl:grid-cols-5", 6: "xl:grid-cols-6", 7: "xl:grid-cols-7", 8: "xl:grid-cols-4", 9: "xl:grid-cols-5" };

export const Stat = ({ icon: Icon, label, value, hint, testid, tone = "primary", onClick }) => (
  <Card onClick={onClick} title={hint ? `${label} · ${hint}` : label} className={`px-3.5 py-3 flex items-center gap-3 min-w-0 glow-border transition-colors ${onClick ? "cursor-pointer hover:border-primary" : ""} ${tone === "amber" ? "border-amber-500/40 hover:border-amber-500" : ""}`} data-testid={testid}>
    {Icon && <div className={`w-9 h-9 rounded-lg flex items-center justify-center shrink-0 ${tone === "amber" ? "bg-amber-500/15 text-amber-500" : "bg-primary/15 text-primary"}`}><Icon className="w-[18px] h-[18px]" /></div>}
    <div className="min-w-0">
      <p className="text-xl font-head font-bold leading-tight truncate">{value}</p>
      <p className="text-xs text-muted-foreground leading-snug [overflow-wrap:anywhere]">{label}{hint && <span className="opacity-70"> · {hint}</span>}</p>
    </div>
  </Card>
);

export const StatStrip = ({ children, testid }) => {
  const n = React.Children.toArray(children).filter(Boolean).length;
  return <div className={`grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 ${COLS[n] || "xl:grid-cols-4"} gap-2.5`} data-testid={testid}>{children}</div>;
};
